import { useSelector } from "react-redux";
import { connectionSelector } from "../slices/connectionSlice";
import { useReplayContext } from "../contexts/replayContext";
export const useUiIsLocked = () => {
    const connection = useSelector(connectionSelector);
    const replayState = useReplayContext();
    return (!import.meta.env.DEV && (replayState.replayMode ||
        !!(!replayState.replayMode && (!connection || (connection.sectorId && !connection.isActive)))));
};
//# sourceMappingURL=useUiIsLocked.js.map